module.exports = __webpack_public_path__ + "img/icono-almacen.5bece53a.svg";